<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="small-panel" @click.stop>
                <div class="dialog-title" v-t="'message.title_client_setting_confirming'">
                </div>
                <hr class="dialog-hr">
                <div v-if="confirmInfo.connect" class="dialog-body">
                    <span v-if="confirmInfo.linkType == 0" v-html="$t('message.info_send_allow_link_request', { tenantName: confirmInfo.tenantName })"></span>
                    <span v-else>
                        <span v-if="confirmInfo.allowCheck" v-html="$t('message.info_confirm_link_connect')"></span>
                        <span v-else v-html="$t('message.info_send_want_link_request', { tenantName: confirmInfo.tenantName })"></span>
                    </span>
                </div>
                <div v-else class="dialog-body" v-t="'message.info_link_disconnected'"></div>
                <hr class="dialog-hr">
                <div v-if="(confirmInfo.connect & confirmInfo.allowCheck)" class="dialog-button-field">
                    <el-button class="dialog-cancel-button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                    <el-button class="dialog-ok-button" @click="$emit('allowLink')">OK</el-button>
                </div>
                <div v-else class="dialog-button-field" style="text-align:center">
                    <el-button class="dialog-ok-button" style="width:160px" @click="$emit('confirm')">OK</el-button>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>

export default {
    data() {
        return {
        };
    },
    methods: {
    },
    components: {
    },
    created: function() {
    },
    props: [ 'confirmInfo' ]
}
</script scoped>
<style scoped>

.dialog-description {
    padding: 20px;
}
.dialog-body {
    padding: 20px;
    font-size: 14px;
}

</style scoped>
